module.exports = __webpack_public_path__ + "img/fen.f71e8d2d.png";